import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/cn';

export type SkeletonKind = 'lines' | 'table' | 'card';

const pulse = 'animate-pulse rounded bg-mint-tint motion-reduce:animate-none';

/** Loading placeholder — `mint-tint` bars, per *Basis layout* ("Laden:
 * Skeleton-balken in mint-tint i.p.v. 'Loading …'-tekst"). The sentence
 * itself stays for screen readers via `sr-only` + `role="status"`, sitting
 * outside the `aria-hidden` bars so it stays in the accessibility tree. */
export function Skeleton({
  kind = 'lines',
  className,
}: {
  kind?: SkeletonKind;
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <div className={cn('w-full', className)}>
      <div aria-hidden="true">
        {kind === 'lines' && (
          <div className="flex flex-col gap-2">
            <div className={cn(pulse, 'h-4 w-full')} />
            <div className={cn(pulse, 'h-4 w-5/6')} />
            <div className={cn(pulse, 'h-4 w-2/3')} />
          </div>
        )}
        {kind === 'table' && (
          <div className="flex flex-col gap-2">
            {[0, 1, 2, 3].map((row) => (
              <div key={row} className={cn(pulse, 'h-10 w-full')} />
            ))}
          </div>
        )}
        {kind === 'card' && <div className={cn(pulse, 'h-32 w-full rounded-2xl')} />}
      </div>
      <span className="sr-only" role="status">
        {t('ui.loading')}
      </span>
    </div>
  );
}
